<template>
  <div class="setup-content contact-info" id="step-6">
    <div class="form-row justify-content-between">
      <div>
        <h3 class="color-darkblue">Attachments</h3>
      </div>
      <div v-if="viewAllfields" class="verified-checkbox mr-4">
        <div class="form-group row claim-verified-checkbox pt-7">
          <label for="attach_section_verified" class="control-label claim-mr-2">Verified:</label>
          <input type="checkbox" v-model="section_verified" :disabled="disableAllFields" name="attach_section_verified"
            id="attach_section_verified" />
        </div>
      </div>
    </div>
    <div class="table-responsive-sm mt-2">
      <table class="table table-bordered table-sm" style="table-layout: fixed;">
        <thead>
          <tr class="table-primary">
            <th scope="col" style="width: 5%;" class="text-left">#</th>
            <th scope="col" class="text-left">Attachment Type</th>
            <th scope="col" class="text-left">File Name</th>
            <th scope="col" class="text-left">File Upload</th>
            <th scope="col" style="width: 8%;" class="text-left">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in rows" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <v-select class="close-remove" v-model="row.attachmentType" :id="'attachmentType_' + index"
                placeholder="Select Attachment Type" label="text" :options="attachmentTypeArr"
                @change="attachmentTypeChanged($event, index)" :disabled="disableCheck">
              </v-select>
              <div class="field-error ml-0">{{ row.attachmentTypeErrorMsg }}</div>
            </td>
            <td>
              <input type="text" :id="'uploadFileName' + index" class="form-control" v-model="row.fileName"
                placeholder="File Name" :disabled="disableCheck">
              <div class="field-error ml-0">{{ row.fileNameErrorMsg }}</div>
            </td>
            <td>
              <template v-if="row.fileLink == null">
                <input type="file" @change="handleSelectedFile($event, index)" :id="'uploadFile' + index" :disabled="disableCheck">
                <div class="field-error ml-0">{{ row.fileErrorMsg }}</div>
              </template>
              <template v-else>
                <div class="row">
                  <div class="col d-flex align-items-center">
                    <a v-on:click="goToGetDocumentPath($event, row.fileLink)" title="View Part Attachment"
                      href="javascript:void(0);" style="font-size: 15px;">
                      <i class="fp-text-document"></i> Attached File
                    </a>
                    <a href="javascript:void(0);" style="margin-left: 15px;margin-top: 4px;"
                      v-on:click="removeFileLink(index);" class="ms-1" 
                      :class="{ 'custom-disabled-link': disableCheck }">
                      <i class="fp-remove"></i>
                    </a>
                  </div>
                  <div class="col"></div>
                </div>
              </template>

            </td>
            <td class="text-center valign-middle">
              <template v-if="userObj.id == row.created_by">
                <a href="javascript:void(0);" :class="{ 'custom-disabled-link': disableCheck }"
                    title="Remove" v-on:click="removeRow(index);"> <i class="fp-delete"></i>
                </a>
              </template>
              <template v-else>
                <span class="close-row"> _ </span>
              </template>

            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="btn-groups mb-4">
      <template>
        <button type="button" :disabled="disableCheck" v-on:click.prevent="addRow()" class="btn btn-primary">
          <i class="fp-add"></i> Add Attachment
        </button>
      </template>
    </div>
    <div class="alert alert-warning hide col-sm-6">
      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span
          aria-hidden="true">&times;</span></button>
      <strong class="errormsg"></strong>
    </div>
    <div class="alert alert-warning hide w-50">
      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span
          aria-hidden="true">&times;</span></button>
      <strong class="errormsg"></strong>
    </div>

  </div>
</template>
<script>
import Vue from "vue";
import { contractMixins } from '../../mixins/contractMixins';
import { commonMixins } from '../../mixins/commonMixins';
import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);

import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  name: "EvAttachmentTab",
  components: {
    vueDropzone: vue2Dropzone,
    appFooter: () => import('@/components/Footer')
  },
  mixins: [commonMixins, contractMixins],
  props: {
    viewAllfields: {
      type: Boolean,
      default: false
    },
    dealerFieldsDisabled: {
      type: Boolean,
      default: false
    },
    disableAllFields: {
      type: Boolean,
      default: false
    },
    claimStatus: {
      type: String,
      default: ''
    },
    canViewAllFields: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dropZonePreviewFiles: [],
    fileerror_msg: "",
    docArr: [],
    validateDocs: [],
    filesArr: [],
    warranty_id: "",
    isEdit: false,
    attachmentRequired: false,
    section_verified: false,
    rows: [],
    attachmentTypeArr: [
      'Repair Order',
      'Sublet Invoices',
      'Parts Invoice',
      'Pictures',
      'Diagnostics Reports'
    ],
    attachmentId: '',
    rowsToDelete: [],
    userObj: JSON.parse(localStorage.getItem("user_obj")),
    initialAttachmentData: '',
    currentAttachmentData: ''
  }),
  computed:{
    disableCheck(){
      return !(this.claimStatus === 'Open' && this.canViewAllFields === false) && (this.disableAllFields || this.claimStatus === 'In Process');
    }
  },
  mounted() {
    var self = this;
  },
  methods: {

    addRow() {
      var self = this;
      var success = true;
      var index = self.rows.length - 1;
      var success = self.validateRows(index);

      if (success) {
        self.rows.push({
          id: "",
          attachmentType: '',
          attachmentTypeErrorMsg: '',
          fileName: '',
          fileNameErrorMsg: '',
          file: '',
          fileErrorMsg: '',
          fileLink: null,
          created_by: self.userObj.id
        });
      }
    },
    attachmentTypeChanged(newValue, index) {
      if (newValue == null || newValue == '') {
        this.rows[index].attachmentType = '';
      }
    },
    validateRows(index) {
      var self = this;
      var success = true;
      if (self.rows[index] !== undefined) {
        self.rows[index].attachmentTypeErrorMsg = '';
        self.rows[index].fileNameErrorMsg = '';
        self.rows[index].fileErrorMsg = '';
        if (self.rows[index].attachmentType == '') {
          self.rows[index].attachmentTypeErrorMsg = 'Attachment Type is Required.';
          success = false;
        }

        if (!self.rows[index].fileName) {
          self.rows[index].fileNameErrorMsg = 'File Name is Required.';
          success = false;
        }
        if (self.rows[index].fileLink == null) {
          if (!self.rows[index].file) {
            self.rows[index].fileErrorMsg = 'Attachment File is Required.';
            success = false;
          }
        }
      }
      return success;
    },
    validateAllRowsForSend() {
      var self = this;
      var success = true;
      var overallSuccess = true;
      for (var i = 0; i < self.rows.length; i++) {
        success = self.validateRows(i);
        if (!success) {
          overallSuccess = false;
        }
      }
      return overallSuccess;
    },
    removeRow(index) {
      var self = this;
      if (self.rows.length > 0) {
        if (self.rows[index].id != "") {
          self.rowsToDelete.push({
            id: self.rows[index].id
          });
        }
        self.rows.splice(index, 1);
      }
    },
    handleSelectedFile(event, index) {
      var self = this;
      self.rows[index].fileErrorMsg = '';
      const file = event.target.files[0]; // Get the selected file
      if (file) {
        // Handling file
        const maxSize = 10000000; // 10MB
        if (file.size > maxSize) {
          self.rows[index].fileErrorMsg = "The file size is too large. Please upload a file smaller than 10MB.";
        } else {
          self.rows[index].file = file;
        }
      }
    },
    gotoBack: function (flag) {
      var self = this;
      self.gotoBackStepMixins(flag);
    },
    gotoNext: function (flag) {
      var self = this;
      var success = self.validateBeforeSubmit();
      if (success) {
        self.emitDataToParent();
        self.gotoNextStepMixins(flag);
      }
    },
    submit() {
      var self = this;
      var success = self.validateBeforeSubmit();
      if (success) {
        self.emitDataToParent();
      }
    },

    //load files in drop zone
    loadFilesPreview: function () {
      var self = this;
      self.docArr = [];
      self.validateDocs = [];
      if (self.dropZonePreviewFiles.length > 0) {
        for (var i = 0; i < self.dropZonePreviewFiles.length; i++) {
          var url = self.dropZonePreviewFiles[i].url;
          // get file path from url
          self.docArr.push(self.getFilePathFromUrl(self.dropZonePreviewFiles[i].url));
          self.validateDocs.push({
            file_name: self.dropZonePreviewFiles[i].display_name,
            extension: self.dropZonePreviewFiles[i].extension
          });
        }
      }
    },
    getFilePathFromUrl(value) {

      var path = "";
      var src = value.split('/');
      var file_name = src[src.length - 1];
      var orgPath = src[src.length - 2];
      path = orgPath + "/" + file_name;
      return path;

    },
    deleteWarrantyFile: function (key, file) {

      var self = this;

      if (confirm('Are you sure that you want to remove file? ')) {

        if (self.warranty_id != '' && self.warranty_id != undefined) {
          self.$parent.loading = true;

          $.ajax({
            url: process.env.ROOT_API + "/remove-warranty-claim-file",
            type: "POST",
            crossDomain: true,
            dataType: "json",
            headers: {
              'Accept': "application/json",
              "Access-Control-Allow-Origin": "*",
              'Authorization': "Bearer " + localStorage.getItem("tkn"),
              "Access-Control-Allow-Headers":
                "Origin, Content-Type, Authorization,X-Requested-With",
              "Cache-Control": "no-cache"
            },
            data: {
              warranty_id: self.warranty_id,
              doc_path: file
            },
            success: function (data) {
              self.$parent.loading = false;
              if (data.status == "success") {
                self.filesArr.splice(key, 1);
                self.docArr.splice(key, 1);
                self.validateDocs.splice(key, 1);
                self.dropZonePreviewFiles.splice(key, 1);
                self.emitDataToParent('delete_attached');
                // self.loadClaimData(self.warranty_id);
                if (self.valuesFound) {
                  self.valuesFound = false;
                  self.matchingValuesError = [];
                }
              }
            },
            error: function (jqXHR, exception) {
              self.$parent.loading = false;
              self.filesArr.splice(key, 1);
              self.docArr.splice(key, 1);
              self.validateDocs.splice(key, 1);
              self.generateStatusCodeMessage(jqXHR, true, 'vendor-invoice-doc-remove');
            }
          });

        } else {
          self.filesArr.splice(key, 1);
          self.$refs.files.value = '';
        }
      }

    },
    removedSelectedFile(file, xhr, error) {
      var self = this;
      self.fileerror_msg = "";
      if (file.xhr != undefined) {
        var fileName = JSON.parse(file.xhr.response).content;

        var fileArr = fileName.split("/");

        self.removeFileFromServer(fileArr[1], "temp");

        for (var i = 0; i < self.docArr.length; i++) {
          if (self.docArr[i].includes(fileName)) {
            self.docArr.splice(i, 1);
            self.validateDocs.splice(i, 1);
            self.filesArr.splice(i, 1);
          }
        }
      }
    },
    removeFileFromServer(file, flag) {
      var self = this;
      var billId = self.$route.params.id;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/remove-warranty-claim-file",
        type: "POST",
        data: {
          doc_path: file,
          bill_id: billId,
          flag: flag
        },
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          "Access-Control-Allow-Headers":
            "Origin, Content-Type, Authorization,X-Requested-With",
          "Cache-Control": "no-cache"
        },
        dataType: "json",
        success: function (data) {
          self.loading = false;
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, true, 'vendor-inv-doc-remove')
        }
      });
    },
    removeAllFiles() {
      var self = this;
      self.$refs.warrentyClaimDropZone.removeAllFiles();
    },
    storeDocument(file, response) {
      var self = this;
      self.fileerror_msg = "";
      var uploadResponse = response;

      //push doc path in doc array
      self.docArr.push(uploadResponse.content);
      self.filesArr.push(file);
      if (file.type != undefined) {
        var extension = file.type.split("/");
        self.validateDocs.push({
          file_name: file.name,
          size: file.size,
          extension: extension[1]
        });
      }
    },
    afterComplete(file, response) {
      var self = this;
    },
    validateBeforeSubmit() {
      var self = this;
      var success = true;

      if (self.docArr != null && self.docArr.length > 0) {
        if (self.validateDocs.length > 0) {
          for (var i = 0; i < self.validateDocs.length; i++) {
            let fileObj = self.validateDocs[i];

            if (fileObj.extension != undefined) {
              if (fileObj.extension == "jpeg" || fileObj.extension == "png" || fileObj.extension == "jpg" || fileObj.extension == "pdf" || fileObj.extension == "doc" || fileObj.extension == "docx" || fileObj.extension == "msword" || fileObj.extension == "vnd.openxmlformats-officedocument.wordprocessingml.document") {

              } else {
                self.fileerror_msg = "Only Images or PDF or Doc Files Are Allowed (.jpg / .jpeg / .png / .pdf / .doc / .docx).";
                success = false;
              }
            }

            if (fileObj.size != undefined) {
              if (fileObj.size > 10000000) {
                self.fileerror_msg = "File size should not be greater than 10 MB.";
                success = false;
              }
            }
          }
        }
        if (self.docArr.length > 5) {
          self.fileerror_msg = "Cannot upload more than 5 files.";
          success = false;
        }
      } else {
        if (self.attachmentRequired) {
          self.fileerror_msg = "File needs to be uploaded since, price was input by user in part tab!";
          success = false;
        }
      }
      return success;
    },
    emitDataToParent(flag = null) {
      var self = this;
      const dataToSend = {
        attachmentRows: self.rows,
        verified: self.section_verified,
        attachmentId: self.attachmentId,
        rowsToDelete: self.rowsToDelete,
      };
      self.$emit("send-attachment-data-to-parent", dataToSend, flag);
    },
    getAttachments(attachments, warranty_claim_id) {
      var self = this;
      self.isEdit = true;
      self.warranty_id = warranty_claim_id;
      if (attachments.file_path != null) {
        self.dropZonePreviewFiles = attachments.file_path;
      }
      if (self.dropZonePreviewFiles != null) {
        self.loadFilesPreview();
      }
    },
    checkAttachmentRequired(attachmentRequired) {
      var self = this;
      self.attachmentRequired = attachmentRequired;
    },
    getDataFromParent(attachmentData) {
      this.populateAttachmentLineItems(attachmentData.attachment_line_items);
      this.section_verified = (attachmentData.verified == 0) ? false : true;
      this.attachmentId = attachmentData.id;
      // todo need to handle the part attachment data data
      this.$nextTick(() => {
        this.populateInitialAttachmentData(true);
      });
    },
    populateInitialAttachmentData(flag){
      if(flag) {
        setTimeout(() => {
          this.setInitialValue(flag);
        }, 500);
      } else {
        return this.setInitialValue(flag);
      }
    },
    setInitialValue(flag){
      const attachmentData = JSON.stringify({
        attachmentRows: this.rows,
        verified: this.section_verified,
        attachmentId: this.attachmentId,
        rowsToDelete: this.rowsToDelete,
      });

      if (flag) {
        this.initialAttachmentData = '';
        this.initialAttachmentData = attachmentData;
      } else {
        this.currentAttachmentData = '';
        this.currentAttachmentData = attachmentData;
        
        return this.initialAttachmentData !== this.currentAttachmentData;
      }
    },
    goToGetDocumentPath(event, link) {
      event.preventDefault();
      var self = this;
      var path = link;
      var flag = '';
      var id = 0;
      self.getDocumentPath(id, path, flag);
    },
    removeFileLink(index) {
      this.rows[index].fileLink = null;
    },
    populateAttachmentLineItems(attachmentLineItems) {
      for (let i = 0; i < attachmentLineItems.length; i++) {
        this.rows.push({
          id: attachmentLineItems[i].id,
          attachmentType: attachmentLineItems[i].attachment_type,
          attachmentTypeErrorMsg: "",
          fileName: attachmentLineItems[i].file_name,
          fileNameErrorMsg: "",
          file: "",
          fileErrorMsg: "",
          fileLink: (attachmentLineItems[i].uploaded_file != "") ? attachmentLineItems[i].uploaded_file : null,
          created_by: attachmentLineItems[i].created_by === null ? this.userObj.id : attachmentLineItems[i].created_by

        });
      }
    },
    clearAllFields() {
      var self = this;
      self.section_verified = false;

      self.rows = [];
      self.rowsToDelete = [];
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/EvAttachmentTab.vue